


import React, { useState } from "react";
import { Box, Typography, TextField, Button } from "@mui/material";
import { motion } from "framer-motion";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ContactPage = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Input Validation
    if (!formData.fullName || !formData.email || !formData.phone || !formData.subject || !formData.message) {
      toast.error("All fields are required.", {
        position: "top-center",
        autoClose: 3000,
      });
      return;
    }

    try {
      const res = await axios.post("https://wedding-backend-pi.vercel.app/api/contact", formData);
      toast.success("Message sent successfully!", {
        position: "top-center",
        autoClose: 3000,
      });
      setFormData({ fullName: "", email: "", phone: "", subject: "", message: "" });
    } catch (err) {
      toast.error("Failed to send the message. Please try again.", {
        position: "top-center",
        autoClose: 3000,
      });
    }
  };

  return (
    <Box>
      {/* Toast Notifications */}
      <ToastContainer />

      {/* Header Section */}
      <Box sx={{ textAlign: "center", py: 4, px: { xs: 2, md: 4 } }}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: "bold",
            mb: 2,
          }}
          component={motion.div}
          whileHover={{ scale: 1.05, textShadow: "0 0 10px rgba(255, 255, 255, 0.8)" }}
          transition={{ duration: 0.3 }}
        >
          Contact Us
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Get in touch with us & stay updated.
        </Typography>
      </Box>

      {/* Contact Section */}
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          gap: 4,
          px: { xs: 2, md: 8 },
          py: 4,
        }}
      >
        {/* Left Column - Contact Details */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            gap: 4,
          }}
        >
          {[{
              title: "Address",
              value: "123 Main Street, City, Country",
            },
            { title: "Email", value: "weddingbliss@gmail.com" },
            { title: "Phone", value: "+1 234 567 890" },
          ].map((item, index) => (
            <Box
              key={index}
              sx={{
                p: 3,
                borderRadius: 2,
                boxShadow: 3,
                height: 50,
                backgroundColor: "#f9f9f9",
                textAlign: "center",
              }}
              component={motion.div}
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.3 }}
            >
              <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
                {item.title}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {item.value}
              </Typography>
            </Box>
          ))}

          {/* Google Maps Integration */}
          <Box
            sx={{
              p: 3,
              borderRadius: 2,
              boxShadow: 3,
              backgroundColor: "#f9f9f9",
              height: 300,
              overflow: "hidden",
            }}
          >
            <iframe
              title="Google Maps"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31108.985019041863!2d-74.0060156!3d40.7127281!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c250b01c937cd1%3A0x8b78e1a7bc3b82cd!2s123%20Main%20Street%2C%20New%20York%2C%20NY%2010001%2C%20USA!5e0!3m2!1sen!2sin!4v1684053877628!5m2!1sen!2sin"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
            ></iframe>
          </Box>
        </Box>

        {/* Right Column - Contact Form */}
        <Box
          sx={{
            flex: 1,
            p: 4,
            borderRadius: 2,
            boxShadow: 3,
            backgroundColor: "#f9f9f9",
            display: "flex",
            flexDirection: "column",
            gap: 6,
            height: "auto",
            justifyContent: "flex-start",
          }}
          component={motion.div}
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <Typography
            variant="h5"
            sx={{ fontWeight: "bold", mb: 3 }}
            component={motion.div}
            whileHover={{ scale: 1.05 }}
            transition={{ duration: 0.3 }}
          >
            Leave Us a Message
          </Typography>
          <form onSubmit={handleSubmit}>
            <TextField
              label="Full Name"
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
              variant="outlined"
              fullWidth
              sx={{ mb: 4 }}
            />
            <TextField
              label="Email Address"
              name="email"
              value={formData.email}
              onChange={handleChange}
              variant="outlined"
              fullWidth
              sx={{ mb: 4 }}
            />
            <TextField
              label="Phone Number"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              variant="outlined"
              fullWidth
              sx={{ mb: 4 }}
            />
            <TextField
              label="Subject"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              variant="outlined"
              fullWidth
              sx={{ mb: 4 }}
            />
            <TextField
              label="Message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              variant="outlined"
              fullWidth
              multiline
              rows={4}
              sx={{ mb: 4 }}
            />
            <Button
              type="submit"
              variant="contained"
              color="primary"
              sx={{
                px: 3,
                py: 1,
                borderRadius: 30,
                textTransform: "none",
              }}
              component={motion.button}
              whileHover={{ scale: 1.1 }}
              transition={{ duration: 0.3 }}
            >
              Send Message
            </Button>
          </form>
        </Box>
      </Box>
    </Box>
  );
};

export default ContactPage;
